import { Navbar } from '../components/NavBar';

export const About = () => (
	<div className="about">
		<Navbar />
		Made by some idiots.
	</div>
);
